import { useState } from "react";
import {
  HiddenInput,
  SwitchButton,
  SwitchContainer,
  SwitchLabel,
  SwitchWrapper
} from "./styled";

interface ToggleSwitchProps {
  checkboxName: string;
  text: string;
  checked: boolean;
  onChange: (checkboxName: string, checked: boolean) => void;
}

export const Switch = ({
  checkboxName,
  text,
  checked,
  onChange,
}: ToggleSwitchProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  const toggleChecked = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    onChange(checkboxName, newChecked);
  };

  return (
    <SwitchContainer>
      <SwitchWrapper>
        <HiddenInput
          type="checkbox"
          checked={isChecked}
          onChange={toggleChecked}
          id={`${checkboxName}-switch-id`}
        />
        <SwitchLabel checked={isChecked} htmlFor={`${checkboxName}-switch-id`}>
          <SwitchButton checked={isChecked} />
        </SwitchLabel>
      </SwitchWrapper>
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </SwitchContainer>
  );
};
